var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.dialogTitle,
        width: "720px",
        "append-to-body": "",
        "custom-class": "soc-togo-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("p", { staticClass: "soc-togo-sub" }, [_vm._v(_vm._s(_vm.dialogSub))]),
      _vm._v(" "),
      _c("soc-process-rail", {
        attrs: {
          nodes: _vm.railNodes,
          "now-label": _vm.$t("route.socProcessNetTogoNow")
        },
        on: { select: _vm.onRail }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "soc-togo-hint" }, [
        _vm._v(_vm._s(_vm.$t("route.socProcessNetTogoHint")))
      ]),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("route.socProcessNetTogoClose")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.onVoice }
            },
            [_vm._v(_vm._s(_vm.$t("route.socProcessNetTogoVoice")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7afdc711", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7afdc711","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocWorkOrderTogoDialog.vue
// module id = null
// module chunks = 